import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { assertBetaAccess } from "@/lib/beta-access";


const DEFAULTS = { email_leads: true, email_weekly: true, email_product: false };

export const getMyPreferences = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    await assertBetaAccess(context.supabase, context.userId);
    const { data } = await context.supabase

      .from("user_preferences")
      .select("notifications")
      .eq("user_id", context.userId)
      .maybeSingle();
    return { notifications: { ...DEFAULTS, ...((data?.notifications as any) ?? {}) } };
  });

export const updateMyPreferences = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d) => z.object({
    notifications: z.object({
      email_leads: z.boolean().optional(),
      email_weekly: z.boolean().optional(),
      email_product: z.boolean().optional(),
    }),
  }).parse(d))
  .handler(async ({ context, data }) => {
    await assertBetaAccess(context.supabase, context.userId);
    const { error } = await context.supabase

      .from("user_preferences")
      .upsert({ user_id: context.userId, notifications: data.notifications }, { onConflict: "user_id" });
    if (error) throw error;
    return { ok: true };
  });
